<script>
    import Layout from "../../../layouts/main";
    import PageHeader from "@/components/page-header";
    import appConfig from "@/app.config";
    import Forms from "../../../../mixins/Forms";

    import axios from 'axios';

    /**
     * Tag template edit component
     */
    export default {
        page: {
            title: "Edit Tag Template",
            meta: [{name: "description", content: appConfig.description}]
        },
        components: {Layout, PageHeader},
        mixins: [Forms],
        created() {
            this.loadTagTemplate(this.$route.params.id);
        },
        data() {
            return {
                title: "Edit Tag Template",
                items: [
                    {
                        text: "Settings",
                        href: "#"
                    },
                    {
                        text: "Edit Tag Template",
                        active: true
                    }
                ],
                tagTemplate: null,
                serverErrors: [],
                isLoading: false,
                isSaving: false
            };
        },
        methods: {
            loadTagTemplate(id) {
               let vm = this;
               vm.tagTemplate = null;
               vm.isLoading = true;
               axios.get(API_BASE + '/tag-templates/' + id).then(r => {
                   vm.isLoading = false;
                   vm.tagTemplate = r.data;
               }).catch(e => {
                   console.log(e);
                   vm.isLoading = false;
                   vm.setErrors(e);
               });
           },

            attemptSave() {
                this.save();
            },

            save() {
                let vm = this;
                vm.isSaving = true;
                axios.put(API_BASE + '/tag-templates/' + this.tagTemplate.id, {
                    name: vm.tagTemplate.name
                }).then(r => {
                    vm.isSaving = false;
                    vm.$router.push('/settings/tag-templates/');
                    this.$notify.success({
                        title: 'Success!',
                        message: 'Tag template updated successfully'
                    });
                }).catch(e => {
                    console.log(e);
                    vm.isSaving = false;
                    vm.setErrors(e);
                });
            }
        }
    };
</script>

<template>
    <Layout>
        <PageHeader :title="title" :items="items"/>
        <errors :error-list="serverErrors"></errors>
        <loading-screen :is-loading="isLoading||isSaving"></loading-screen>
        <div class="row" v-if="tagTemplate">
            <div class="col-lg-12">
                <div class="card">
                    <div class="card-body">
                        <!--            <h4 class="card-title mb-4">Ticket Details</h4>-->
                        <form @submit.prevent="attemptSave">
                            <div class="form-group row mb-4">
                                <label for="name" class="col-form-label col-lg-2">Name</label>
                                <div class="col-lg-10">
                                    <input
                                            id="name"
                                            name="name"
                                            type="text"
                                            class="form-control"
                                            v-model="tagTemplate.name"
                                            autofocus
                                    />
                                </div>
                            </div>
                        </form>
                        <div class="row justify-content-end">
                            <div class="col-lg-10">
                                <button type="submit" class="btn btn-itg-dark" @click.prevent="attemptSave">Update</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- end row -->
    </Layout>
</template>

<style scoped>
</style>
